import React from "react";
import { func } from "prop-types";

const FilterButton = ({ onClick }) => (
    <button
        className="btn filter-btn"
        type="button"
        onClick={onClick}
    >
        <i className="fa fa-filter" />
    </button>
);

FilterButton.propTypes = {
    onClick: func
};

export default FilterButton;